const ApiAttributesKeys = {
  chapterIdKey: 'chapterId',
  readingNameKey: 'name',
  readingIdKay: 'readingId',
  questionIdKey: 'id',
  descriptionKey: 'description',
  isAttemptedKey: 'cfa1_2024_notes_stats.answer_status', //*The key is associated with another table, which is why we cannot modify it.
};
module.exports = ApiAttributesKeys;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/Notes/ViewNotesList/ApiAttributesKeys.js